import { ApolloClient, InMemoryCache, createHttpLink, from } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import { isNil } from 'lodash'
import { isDevelopment, isStg } from 'modules/app-config/environment'
import { STG_ENV } from 'modules/app-config/stg-env'
import pjson from '../../package.json'

const DEV_ENROLLME_GATEWAY_URI = 'https://enrollmegateway.dev.surecolabs.com/graphql'
const STG_ENROLLME_GATEWAY_URI = STG_ENV.enrollmeGatewayGraphqlUrl
const PROD_ENROLLME_GATEWAY_URI = 'https://enrollmegateway.docday.com/graphql'
const getGatewayUri = () => {
  if (isStg()) {
    return STG_ENROLLME_GATEWAY_URI
  }
  if (isDevelopment()) {
    return DEV_ENROLLME_GATEWAY_URI
  }
  return PROD_ENROLLME_GATEWAY_URI
}
const URI = getGatewayUri()

const httpLink = createHttpLink({
  uri: URI,
})

const authLink = setContext((_, { headers }) => {
  const fullToken = localStorage.getItem('admin-token')
  const { idToken } = JSON.parse(fullToken) || {}
  return {
    headers: {
      ...headers,
      authorization: isNil(idToken) ? '' : idToken,
    },
  }
})

const client = new ApolloClient({
  link: from([authLink, httpLink]),
  cache: new InMemoryCache(),
  name: 'enrollme-admin-web',
  version: pjson.version,
})

export default client
